export enum PaymentType {
    NotSpecified = -1,
    CoinsAndBills = 0,
    CoinsOnly = 1,
    BillsOnly = 2,
}